import { PolicyConfigFormValues } from '../../PolicyConfigurationFormSection';

export type AllowedSourceScope = 'global' | 'namespaces';

export interface AllowedSource {
  registryUrlPrefix: string;
  scope: AllowedSourceScope;
  namespaces: string[];
}

export const DEFAULT_ALLOWED_SOURCES: AllowedSource[] = [
  { registryUrlPrefix: 'registry.k8s.io', scope: 'global', namespaces: [] },
  {
    registryUrlPrefix: 'docker.io/portainer',
    scope: 'global',
    namespaces: [],
  },
  {
    registryUrlPrefix: 'docker.io/openpolicyagent',
    scope: 'global',
    namespaces: [],
  },
];

export interface AccessRow {
  id: number;
  registryId: number | null;
  namespaces: string[];
  registryName?: string; // only for display in datatable
}

/**
 * Type-specific form data for Kubernetes Registry Policy
 * Represents which namespaces each registry is accessible in
 */
export interface KubernetesRegistryTypeSpecificData {
  accessRows: AccessRow[];
  restrictSources: boolean;
  allowedSources: AllowedSource[];
}

/**
 * Complete form values for Kubernetes Registry Policy form
 * Includes both common policy config fields and type-specific data
 */
export interface KubernetesRegistryFormValues
  extends PolicyConfigFormValues,
    KubernetesRegistryTypeSpecificData {}

/**
 * API payload for allowed sources
 */
export interface AllowedSourcePayload {
  RegistryURLPrefix: string;
  Scope: string;
  Namespaces: Array<{ value: string; enforce: boolean }>;
}

/**
 * API payload for Kubernetes Registry Policy
 * Namespaces only per registry (access is at namespace level, not user/team level)
 */
export interface KubernetesRegistryPolicyPayload {
  RegistryAccessPolicies: Record<
    string,
    {
      Namespaces: Array<{ value: string; enforce: boolean }>;
    }
  >;
  RestrictSources: boolean;
  AllowedSources: AllowedSourcePayload[];
}

/**
 * Default initial values for Kubernetes Registry Policy (create mode)
 */
export const KUBERNETES_REGISTRY_INITIAL_VALUES: KubernetesRegistryFormValues =
  {
    name: '',
    environmentGroupIds: [],
    accessRows: [],
    restrictSources: false,
    allowedSources: [],
  };
